(function () {
  'use strict';

  var SIZE_CHART = [
    { size: 'XXS', waistMin: 22, waistMax: 28, hipMin: 28, hipMax: 34 },
    { size: 'XS',  waistMin: 29, waistMax: 34, hipMin: 35, hipMax: 38 },
    { size: 'S',   waistMin: 35, waistMax: 38, hipMin: 39, hipMax: 44 },
    { size: 'M',   waistMin: 39, waistMax: 42, hipMin: 45, hipMax: 48 },
    { size: 'L',   waistMin: 43, waistMax: 46, hipMin: 49, hipMax: 53 },
    { size: 'XL',  waistMin: 47, waistMax: 54, hipMin: 54, hipMax: 58 },
    { size: '2XL', waistMin: 55, waistMax: 58, hipMin: 59, hipMax: 64 },
    { size: '3XL', waistMin: 59, waistMax: 63, hipMin: 65, hipMax: 70 }
  ];

  var CM_TO_IN = 0.393701;

  // =============================================
  // SIZE COMPUTATION (same algorithm as size-quiz.js)
  // =============================================

  function findSizeIndex(measurement, type) {
    var minKey = type + 'Min';
    var maxKey = type + 'Max';

    for (var i = 0; i < SIZE_CHART.length; i++) {
      if (measurement >= SIZE_CHART[i][minKey] && measurement <= SIZE_CHART[i][maxKey]) {
        return i;
      }
    }

    var bestIdx = 0;
    var bestDist = Infinity;
    for (var j = 0; j < SIZE_CHART.length; j++) {
      var dist = Math.max(0, SIZE_CHART[j][minKey] - measurement, measurement - SIZE_CHART[j][maxKey]);
      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = j;
      }
    }
    return bestIdx;
  }

  function computeSize(waistInches, hipInches) {
    var waistIdx = findSizeIndex(waistInches, 'waist');
    var hipIdx = findSizeIndex(hipInches, 'hip');
    var diff = waistIdx - hipIdx;

    if (diff === 0) {
      return { size: SIZE_CHART[waistIdx].size, note: null, betweenSizes: false };
    }
    if (diff === 1) {
      return { size: SIZE_CHART[waistIdx].size, note: 'Your hips measure smaller than the waist, so the Saree Silhouette may be a little loose at your hips.', betweenSizes: false };
    }
    if (diff === -1) {
      return { size: SIZE_CHART[hipIdx].size, note: 'Your waist measures smaller than the hips. We suggest using the drawstring to adjust the waist for a perfect fit.', betweenSizes: false };
    }
    return { size: null, note: null, betweenSizes: true };
  }

  // =============================================
  // MODAL
  // =============================================

  var modal, waistInput, hipInput, unitBtns, unitDisplays, findBtn, resultWrap, validationEl;
  var unit = 'in';

  function createModal() {
    modal = document.createElement('div');
    modal.className = 'sf-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Find Your Size');
    modal.innerHTML =
      '<div class="sf-modal__backdrop"></div>' +
      '<div class="sf-modal__panel">' +
        '<button type="button" class="sf-modal__close" aria-label="Close">&times;</button>' +
        '<h3 class="sf-modal__title">Find Your Size</h3>' +
        '<p class="sf-modal__desc">Enter your waist and hip measurements and we\'ll recommend the right size.</p>' +

        '<div class="sf-modal__unit-toggle" role="radiogroup" aria-label="Measurement unit">' +
          '<button type="button" class="sf-modal__unit-btn is-active" data-unit="in">Inches</button>' +
          '<button type="button" class="sf-modal__unit-btn" data-unit="cm">Centimeters</button>' +
        '</div>' +

        '<div class="sf-modal__fields">' +
          '<div class="sf-modal__field">' +
            '<label for="sf-waist" class="sf-modal__label">Waist</label>' +
            '<div class="sf-modal__input-wrap">' +
              '<input type="number" id="sf-waist" class="sf-modal__input" placeholder="e.g. 32" min="0" max="200" step="0.5" inputmode="decimal">' +
              '<span class="sf-modal__input-unit">in</span>' +
            '</div>' +
          '</div>' +
          '<div class="sf-modal__field">' +
            '<label for="sf-hip" class="sf-modal__label">Hip</label>' +
            '<div class="sf-modal__input-wrap">' +
              '<input type="number" id="sf-hip" class="sf-modal__input" placeholder="e.g. 38" min="0" max="200" step="0.5" inputmode="decimal">' +
              '<span class="sf-modal__input-unit">in</span>' +
            '</div>' +
          '</div>' +
        '</div>' +

        '<div class="sf-modal__validation" role="alert" aria-live="polite"></div>' +

        '<details class="sf-modal__tips">' +
          '<summary class="sf-modal__tips-toggle">' +
            '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><path d="M8 7v4M8 5h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg> ' +
            'How to measure' +
          '</summary>' +
          '<div class="sf-modal__tips-content">' +
            '<p><strong>Waist:</strong> Measure at your natural waistline \u2014 the narrowest part of your torso, above your belly button.</p>' +
            '<p><strong>Hip:</strong> Measure around the fullest part of your hips and buttocks with feet together.</p>' +
          '</div>' +
        '</details>' +

        '<button type="button" class="sf-modal__find" disabled>Find My Size</button>' +

        '<div class="sf-modal__result">' +
          '<div class="sf-modal__result-badge">' +
            '<span class="sf-modal__result-size"></span>' +
            '<span class="sf-modal__result-label">Recommended Size</span>' +
          '</div>' +
          '<p class="sf-modal__result-note" style="display:none;font-weight:700;font-style:italic;color:#6B2D3E;">Your measurements are between sizes. We recommend sizing up for a more comfortable fit.</p>' +
          '<button type="button" class="sf-modal__select-size">Select This Size</button>' +
          '<button type="button" class="sf-modal__retry">Try Different Measurements</button>' +
        '</div>' +

      '</div>';

    document.body.appendChild(modal);

    // Cache refs
    waistInput = modal.querySelector('#sf-waist');
    hipInput = modal.querySelector('#sf-hip');
    unitBtns = modal.querySelectorAll('.sf-modal__unit-btn');
    unitDisplays = modal.querySelectorAll('.sf-modal__input-unit');
    findBtn = modal.querySelector('.sf-modal__find');
    resultWrap = modal.querySelector('.sf-modal__result');
    validationEl = modal.querySelector('.sf-modal__validation');

    // Events
    modal.querySelector('.sf-modal__backdrop').addEventListener('click', closeModal);
    modal.querySelector('.sf-modal__close').addEventListener('click', closeModal);
    unitBtns.forEach(function (btn) { btn.addEventListener('click', toggleUnit); });
    waistInput.addEventListener('input', validate);
    hipInput.addEventListener('input', validate);
    findBtn.addEventListener('click', findSize);
    modal.querySelector('.sf-modal__retry').addEventListener('click', resetModal);
    modal.querySelector('.sf-modal__select-size').addEventListener('click', selectSize);

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function openModal() {
    if (!modal) createModal();
    resetModal();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    waistInput.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function resetModal() {
    waistInput.value = '';
    hipInput.value = '';
    findBtn.disabled = true;
    resultWrap.classList.remove('is-visible');
    validationEl.textContent = '';
    validationEl.style.display = 'none';
    modal.querySelector('.sf-modal__fields').style.display = '';
    modal.querySelector('.sf-modal__find').style.display = '';
    modal.querySelector('.sf-modal__unit-toggle').style.display = '';
    modal.querySelector('.sf-modal__tips').style.display = '';
  }

  function toggleUnit(e) {
    var newUnit = e.currentTarget.dataset.unit;
    if (newUnit === unit) return;

    var wVal = parseFloat(waistInput.value);
    var hVal = parseFloat(hipInput.value);

    if (newUnit === 'cm' && unit === 'in') {
      if (!isNaN(wVal)) waistInput.value = Math.round(wVal / CM_TO_IN * 10) / 10;
      if (!isNaN(hVal)) hipInput.value = Math.round(hVal / CM_TO_IN * 10) / 10;
    } else {
      if (!isNaN(wVal)) waistInput.value = Math.round(wVal * CM_TO_IN * 10) / 10;
      if (!isNaN(hVal)) hipInput.value = Math.round(hVal * CM_TO_IN * 10) / 10;
    }

    unit = newUnit;
    unitBtns.forEach(function (btn) { btn.classList.toggle('is-active', btn.dataset.unit === newUnit); });
    unitDisplays.forEach(function (span) { span.textContent = newUnit; });
    waistInput.placeholder = newUnit === 'cm' ? 'e.g. 81' : 'e.g. 32';
    hipInput.placeholder = newUnit === 'cm' ? 'e.g. 97' : 'e.g. 38';
    validate();
  }

  function validate() {
    var w = parseFloat(waistInput.value);
    var h = parseFloat(hipInput.value);
    var ok = !isNaN(w) && w > 0 && !isNaN(h) && h > 0;
    findBtn.disabled = !ok;
    if (ok) {
      validationEl.textContent = '';
      validationEl.style.display = 'none';
    }
    return ok;
  }

  var lastWaistIn, lastHipIn;

  function findSize() {
    if (!validate()) return;

    var waistIn = parseFloat(waistInput.value);
    var hipIn = parseFloat(hipInput.value);

    if (unit === 'cm') {
      waistIn = Math.round(waistIn * CM_TO_IN * 10) / 10;
      hipIn = Math.round(hipIn * CM_TO_IN * 10) / 10;
    }

    if (waistIn < 20 || waistIn > 70) {
      showValidation('Please enter a waist measurement between 20\u2033 and 70\u2033 (51\u2013178 cm).');
      return;
    }
    if (hipIn < 25 || hipIn > 75) {
      showValidation('Please enter a hip measurement between 25\u2033 and 75\u2033 (64\u2013191 cm).');
      return;
    }

    lastWaistIn = waistIn;
    lastHipIn = hipIn;

    var result = computeSize(waistIn, hipIn);

    // Between sizes — show popup
    if (result.betweenSizes) {
      showBetweenSizesPopup(waistIn, hipIn);
      return;
    }

    // Show result
    modal.querySelector('.sf-modal__result-size').textContent = result.size;
    var noteEl = modal.querySelector('.sf-modal__result-note');
    if (result.note) {
      noteEl.textContent = result.note;
      noteEl.style.display = 'block';
    } else {
      noteEl.style.display = 'none';
    }
    resultWrap.dataset.size = result.size;

    // Hide inputs, show result
    modal.querySelector('.sf-modal__fields').style.display = 'none';
    modal.querySelector('.sf-modal__find').style.display = 'none';
    modal.querySelector('.sf-modal__unit-toggle').style.display = 'none';
    modal.querySelector('.sf-modal__tips').style.display = 'none';
    validationEl.style.display = 'none';
    resultWrap.classList.add('is-visible');
  }

  // =============================================
  // BETWEEN-SIZES POPUP (PDP - uses embedded Shopify contact form)
  // =============================================

  var betweenPopup = null;

  function showBetweenSizesPopup(waistIn, hipIn) {
    if (!betweenPopup) {
      betweenPopup = document.createElement('div');
      betweenPopup.className = 'sz-popup';
      betweenPopup.setAttribute('role', 'dialog');
      betweenPopup.setAttribute('aria-modal', 'true');
      betweenPopup.setAttribute('aria-label', 'Between sizes');
      betweenPopup.innerHTML =
        '<div class="sz-popup__backdrop"></div>' +
        '<div class="sz-popup__panel">' +
          '<button type="button" class="sz-popup__close" aria-label="Close">&times;</button>' +
          '<div class="sz-popup__step sz-popup__step--ask is-active">' +
            '<h3 class="sz-popup__title">You appear to be between sizes</h3>' +
            '<p class="sz-popup__desc">Would you like our team to reach out with a personalized size recommendation?</p>' +
            '<div class="sz-popup__actions">' +
              '<button type="button" class="sz-popup__btn sz-popup__btn--yes">Yes, please</button>' +
              '<button type="button" class="sz-popup__btn sz-popup__btn--no">No, thanks</button>' +
            '</div>' +
          '</div>' +
          '<div class="sz-popup__step sz-popup__step--form">' +
            '<h3 class="sz-popup__title">Get a personalized recommendation</h3>' +
            '<p class="sz-popup__desc">Enter your email and our team will get back to you with sizing advice.</p>' +
            '<div class="sz-popup__form-slot"></div>' +
          '</div>' +
          '<div class="sz-popup__step sz-popup__step--thanks">' +
            '<h3 class="sz-popup__title">Thank you!</h3>' +
            '<p class="sz-popup__desc">Our team will be in touch shortly with a personalized recommendation.</p>' +
            '<button type="button" class="sz-popup__btn sz-popup__btn--done">Close</button>' +
          '</div>' +
        '</div>';

      document.body.appendChild(betweenPopup);

      // Move the real Shopify contact form into the popup
      var formWrap = document.getElementById('sz-contact-form-wrap');
      if (formWrap) {
        var formSlot = betweenPopup.querySelector('.sz-popup__form-slot');
        formSlot.appendChild(formWrap);
        formWrap.style.display = '';
      }

      betweenPopup.querySelector('.sz-popup__backdrop').addEventListener('click', closeBetweenPopup);
      betweenPopup.querySelector('.sz-popup__close').addEventListener('click', closeBetweenPopup);
      betweenPopup.querySelector('.sz-popup__btn--no').addEventListener('click', closeBetweenPopup);
      betweenPopup.querySelector('.sz-popup__btn--done').addEventListener('click', closeBetweenPopup);
      betweenPopup.querySelector('.sz-popup__btn--yes').addEventListener('click', function () {
        betweenPopup.querySelector('.sz-popup__step--ask').classList.remove('is-active');
        betweenPopup.querySelector('.sz-popup__step--form').classList.add('is-active');
        // Set the body field with measurement details
        var bodyField = document.getElementById('sz-contact-body');
        if (bodyField) {
          bodyField.value =
            'I used the size finder and my measurements are between sizes.\n' +
            'Waist: ' + lastWaistIn + ' in\n' +
            'Hip: ' + lastHipIn + ' in\n\n' +
            'Please help me find the right size.';
        }
        var emailInput = formWrap ? formWrap.querySelector('input[type="email"]') : null;
        if (emailInput) emailInput.focus();
      });

      // Intercept form submit: use fetch with the form's own data (includes CSRF token)
      var realForm = formWrap ? formWrap.querySelector('form') : null;
      if (realForm) {
        realForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var formData = new FormData(realForm);
          var submitBtn = realForm.querySelector('button[type="submit"]');
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }

          fetch(realForm.action, {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'text/html' }
          })
          .then(function (res) {
            console.log('[SizeFinder] POST status:', res.status);
            betweenPopup.querySelector('.sz-popup__step--form').classList.remove('is-active');
            betweenPopup.querySelector('.sz-popup__step--thanks').classList.add('is-active');
          })
          .catch(function (err) {
            console.error('[SizeFinder] submit error:', err);
            betweenPopup.querySelector('.sz-popup__step--form').classList.remove('is-active');
            betweenPopup.querySelector('.sz-popup__step--thanks').classList.add('is-active');
          })
          .finally(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Submit'; }
          });
        });
      }

      betweenPopup.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeBetweenPopup();
      });
    }

    // Reset to first step
    betweenPopup.querySelectorAll('.sz-popup__step').forEach(function (s) { s.classList.remove('is-active'); });
    betweenPopup.querySelector('.sz-popup__step--ask').classList.add('is-active');
    var emailInput = betweenPopup.querySelector('#sz-contact-form-wrap input[type="email"]');
    if (emailInput) emailInput.value = '';
    betweenPopup.classList.add('is-open');
  }

  function closeBetweenPopup() {
    if (betweenPopup) {
      betweenPopup.classList.remove('is-open');
    }
  }

  function showValidation(msg) {
    validationEl.textContent = msg;
    validationEl.style.display = 'block';
  }

  // =============================================
  // SELECT SIZE ON PDP VARIANT PICKER
  // =============================================

  function selectSize() {
    var size = resultWrap.dataset.size;
    if (!size) return;

    var clicked = false;

    // Method 1: variant-selects with radio inputs (pill / swatch buttons)
    document.querySelectorAll('variant-selects fieldset input[type="radio"]').forEach(function (input) {
      if (input.value === size) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        clicked = true;
      }
    });

    // Method 2: variant-selects with <select> dropdowns
    if (!clicked) {
      document.querySelectorAll('variant-selects select').forEach(function (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === size || sel.options[i].textContent.trim() === size) {
            sel.selectedIndex = i;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            clicked = true;
            break;
          }
        }
      });
    }

    closeModal();
  }

  // =============================================
  // INIT: Bind trigger links
  // =============================================

  function init() {
    document.querySelectorAll('[data-open-size-finder]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
